import { Button } from 'ui/button/button.module';

import HeaderIcon from 'components/header/headerIcon/headerIcon.module';
import { HeaderOptions } from 'components/header/headerOptions/headerOptions.module';
import { BUTTON_SIZE, BUTTON_TYPE, SCREEN_TYPE } from 'consts/enum';
import { setCustomTagHTML } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';

import { launchHeader } from './launchHeader.model';
import { LaunchHeaderTemplate } from './launchHeader.template';

export default class LaunchHeader {
	constructor(props) {
		this.initData();
		this.initWrapper();
		this.initComponents();
	}

	initData(props) {
		this.data = { ...launchHeader };
		this.setter({
			...props,
			description: ENGT_CHAT.get('config.launchScreenTitle'),
			title: ENGT_CHAT.get('config.launchScreenHeader'),
			startConversation: ENGT_CHAT.get('GENERIC_STRINGS.LAUNCH.START_A_NEW_CONVO') || 'START A NEW CONVERSATION',
		});
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.className = 'engt-launcher-header';
		wrapper.innerHTML = LaunchHeaderTemplate(this.data);

		this.html = wrapper;
	}

	initComponents() {
		const { startConversation, title } = this.data || {};
		const isBotImageAvailable = !!ENGT_CHAT.get('config.chat_header_icon_url');

		/* html */
		const titleTag = `
			<span id="botName" class="engt-launcher-title">
				${title}
			</span>
		`;

		const headerIcon = isBotImageAvailable ? new HeaderIcon({ forceShow: true }).render() : titleTag;
		const headerOptions = new HeaderOptions({
			type: SCREEN_TYPE.LAUNCH,
		}).render();
		const startConvButton = new Button({
			type: BUTTON_TYPE.SECONDARY,
			label: startConversation,
			id: 'startNewConversationBtn',
			size: BUTTON_SIZE.MEDIUM,
			onClick() {
				ENGT_CHAT.get('showChatScreen')();
				setTimeout(() => {
					ENGT_CHAT.get('startNewConversation')();
				}, 500);
			},
			style: 'margin-top: 10px;border: unset;font-weight: 600;',
			radius: 18,
		}).render();

		setCustomTagHTML(this.html.querySelector('header-icon'), headerIcon);
		setCustomTagHTML(this.html.querySelector('header-options'), headerOptions);
		setCustomTagHTML(this.html.querySelector('header-title'), isBotImageAvailable ? titleTag : '');
		setCustomTagHTML(this.html.querySelector('start-conversation'), startConvButton);
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
